import { Component, computed, effect, input, model, OnDestroy, signal } from "@angular/core";
import { CostCenter } from "src/app/models";
import { CdkFixedSizeVirtualScroll, CdkVirtualScrollViewport, CdkVirtualForOf } from "@angular/cdk/scrolling";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatSelect, MatOption, MatLabel, MatFormField } from "@angular/material/select";
import { MatInput } from "@angular/material/input";

@Component({
    selector: "valben-cost-centers-filter",
    templateUrl: "cost-centers.component.html",
    standalone: true,
    imports: [
        CdkVirtualForOf,
        CdkVirtualScrollViewport,
        CdkFixedSizeVirtualScroll,
        MatCheckbox,
        MatFormField,
        MatInput,
        MatSelect,
        MatOption,
        MatLabel,
    ],
})
export class CostCentersFilterComponent implements OnDestroy {
    values = input<CostCenter[]>([]);
    selected = model<string[] | null>([]);
    protected selectedTypes = signal<string[]>([]);
    protected search = signal<string>("");

    protected allChecked = computed(() => {
        const shown = this.shownCostCenters();
        const selected = new Set(this.selected() ?? []);
        return shown.length > 0 && shown.every(c => selected.has(c.masterId));
    });

    protected partiallyChecked = computed(() => {
        const selected = new Set(this.selected() ?? []);
        return !this.allChecked() && this.shownCostCenters().some(c => selected.has(c.masterId));
    });

    protected distinctTypes = computed(() => [
        ...new Set(
            this.values().map(c => c.type).filter(t => !!t && t.trim() !== "")
        ),
        "Ostalo",
    ]);

    protected toggleChecked(id: string): void {
        const set = new Set(this.selected() ?? []);
        if (set.has(id)) set.delete(id);
        else set.add(id);
        this.selected.set([...set]);
    }

    protected toggleAll(checked: boolean): void {
        const selected = new Set(this.selected() ?? []);
        for (const costCenter of this.shownCostCenters()) {
            if (checked) selected.add(costCenter.masterId);
            else selected.delete(costCenter.masterId);
        }
        this.selected.set([...selected]);
    }

    protected shownCostCenters = computed(() => {
        const types = this.selectedTypes();
        const search = this.search();

        const arr = types.length === 0
            ? this.values()
            : this.values().filter(c => this.selectedTypes().includes(
                c.type !== null && c.type.trim() !== "" ? c.type : "Ostalo"
            ));
        return search ? arr.filter(x => (x.names['hr'] ?? "-").toLowerCase().includes(search)) : arr;
    });

    private _filterTimer: ReturnType<typeof setTimeout> | undefined;

    ngOnDestroy(): void {
        clearTimeout(this._filterTimer);
    }

    constructor() {
    }
}
